import React from 'react';

import {Audience} from 'benchling-apps/BenchlingAppDAO';
import {NEAR_BLACK} from 'ui-library/Colors';
import RadioButtonGroup from 'ui-library/inputs/RadioButtonGroup';

// Note: this is different from DEFAULT_AUDIENCE in benchling/benchling_apps/app_catalog.py
export const DEFAULT_AUDIENCE = Audience.PRIVATE;

const PRIVATE_CHOICE_LABEL = 'Private';
const PRIVATE_CHOICE_INFO = 'Restrict install access to specific tenants.';

const PUBLIC_CHOICE_LABEL = 'Public';
const PUBLIC_CHOICE_INFO = 'Anyone can install this app.';

const PRIVATE_CHOICE_INFO_ELEMENT = <div style={{color: NEAR_BLACK}}>{PRIVATE_CHOICE_INFO}</div>;
const PUBLIC_CHOICE_INFO_ELEMENT = <div style={{color: NEAR_BLACK}}>{PUBLIC_CHOICE_INFO}</div>;

const PRIVATE_CHOICE_LABEL_ELEMENT = <b>{PRIVATE_CHOICE_LABEL}</b>;
const PUBLIC_CHOICE_LABEL_ELEMENT = <b>{PUBLIC_CHOICE_LABEL}</b>;

interface AudienceProps {
  state: Audience;
  onChangeState: (value: Audience) => void;
}

export default function AudienceRadioButtons(props: AudienceProps): JSX.Element {
  return (
    <RadioButtonGroup<Audience>
      title="Audience"
      options={[
        {
          label: PRIVATE_CHOICE_LABEL_ELEMENT,
          secondaryLabel: PRIVATE_CHOICE_INFO_ELEMENT,
          value: Audience.PRIVATE,
          dataTestAttrs: {
            component: 'RadioButtonSelector',
            element: 'Private',
          },
        },
        {
          label: PUBLIC_CHOICE_LABEL_ELEMENT,
          secondaryLabel: PUBLIC_CHOICE_INFO_ELEMENT,
          value: Audience.PUBLIC,
          dataTestAttrs: {
            component: 'RadioButtonSelector',
            element: 'Public',
          },
        },
      ]}
      isVertical={true}
      selectedValue={props.state}
      onChange={props.onChangeState}
    />
  );
}
